import { getUtcDate } from ".";
import { CreateSurgeryType } from "../components";
import { Surgery } from "../models";

export const getSurgeryScheduledOnUtc = (values: Surgery | CreateSurgeryType): string | undefined => {
    const date = values.surgeryDate;
    const time = values.surgeryTime;
    const timeZone = values.surgeryTimeZone;
    return getUtcDate(date, time, timeZone);
};
